export default "__VITE_ASSET__d1d99109__"